const DUA_AYAH_RANGES = [
  '1:6-7',
  '2:126',
  '2:127',
  '2:128',
  '2:129',
  '2:201',
  '2:250',
  '2:286',
  '3:8',
  '3:9',
  '3:16',
  '3:26-27',
  '3:38',
  '3:53',
  '3:147',
  '3:191',
  '3:192',
  '3:193',
  '3:194',
  '4:75',
  '5:83',
  '5:114',
  '7:23',
  '7:47',
  '7:89',
  '7:126',
  '7:151',
  '7:155',
  '7:156',
  '10:85-86',
  '10:88',
  '11:47',
  '12:33',
  '12:101',
  '14:35',
  '14:37',
  '14:40',
  '14:41',
  '17:24',
  '17:80',
  '18:10',
  '20:25-28',
  '20:114',
  '21:83',
  '21:87',
  '21:89',
  '23:26',
  '23:29',
  '23:97-98',
  '23:109',
  '23:118',
  '25:65',
  '25:74',
  '26:83-89',
  '27:19',
  '28:16',
  '28:17',
  '28:21',
  '28:22',
  '28:24',
  '29:30',
  '37:100',
  '38:35',
  '40:7-9',
  '40:44',
  '40:55',
  '46:15',
  '59:10',
  '60:4',
  '60:5',
  '66:8',
  '66:11',
  '71:28',
];

const duaAyahKeys = new Set<string>();

for (const entry of DUA_AYAH_RANGES) {
  const [surahPart, ayahPart] = entry.split(':');
  const surahId = Number(surahPart);
  if (!Number.isFinite(surahId) || !ayahPart) continue;

  const [startPart, endPart] = ayahPart.split('-');
  const startAyah = Number(startPart);
  const endAyah = Number(endPart ?? startPart);
  if (!Number.isFinite(startAyah) || !Number.isFinite(endAyah)) continue;

  for (let ayah = startAyah; ayah <= endAyah; ayah += 1) {
    duaAyahKeys.add(`${surahId}:${ayah}`);
  }
}

export function isDuaAyah(surahId: number, ayahNumber: number): boolean {
  return duaAyahKeys.has(`${surahId}:${ayahNumber}`);
}
